import { useQuery } from "vue-query"
import { useContext } from "@nuxtjs/composition-api"

import { ApiPaths } from "@/enums"
import { Locale } from "@/types/models/Locale"
import { Speciality } from "@/types/models/Speciality"
import { CustomQueryHook } from "@/types/vue-query"

export type LocaleParams = {
  localeId: Locale["id"]
}

export const useSpecialityTranslationQuery: CustomQueryHook<
  LocaleParams,
  Speciality[]
> = (params, options) => {
  const { $axios } = useContext()

  return useQuery(
    ["getSpecialityTranslationQuery", params],
    async () => {
      const { data } = await $axios.get<Speciality[]>(
        ApiPaths.GET_SPECIALITY_TRANSLATION,
        { params: { locale_id: params.localeId } },
      )
      return data
    },
    { ...options, keepPreviousData: true },
  )
}

export const useProfessionalSpecialityTranslationQuery: CustomQueryHook<
  LocaleParams,
  Speciality[]
> = (params, options) => {
  const { $axios } = useContext()

  return useQuery(
    ["getProfessionalSpecialityTranslationQuery", params],
    async () => {
      const { data } = await $axios.get<Speciality[]>(
        ApiPaths.GET_PROFESSIONAL_SPECIALITY_TRANSLATION,
        { params: { locale_id: params.localeId } },
      )
      return data
    },
    { ...options, keepPreviousData: true },
  )
}
